import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifiStatusbarConnectedNoInternet226X24Px = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="m12.308 8.788-4.302 5.36-.006.006-.006-.006-4.64-5.785L.259 4.505C.554 4.283 3.532 1.846 8 1.846s7.446 2.437 7.748 2.659l-.831 1.033h-2.61zm2.461 4.135v1.23h-1.23v-1.23zm0-6.154v4.923h-1.23V6.77z"
      />
    </g>
  </svg>
)
export default SvgSignalWifiStatusbarConnectedNoInternet226X24Px
